import { useNavigation } from '@refinedev/core';
import { List, useTable } from '@refinedev/antd';
import { Table, Button, Tag, Space, Avatar } from 'antd';
import { PlusOutlined, UserOutlined, EyeOutlined } from '@ant-design/icons';

interface Staff {
  id: number;
  username: string;
  fullName: string | null;
  phone: string | null;
  isActive: boolean;
  createdAt: string;
  lastLoginAt: string | null;
}

export const StaffList = () => {
  const { create, show } = useNavigation();

  const { tableProps } = useTable<Staff>({
    resource: 'admin/staff',
    syncWithLocation: true,
  });

  const columns = [
    {
      title: 'Xodim',
      key: 'user',
      render: (_: unknown, record: Staff) => (
        <Space>
          <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1ABC9C' }} />
          <div>
            <div>{record.fullName || record.username}</div>
            <div style={{ color: '#7F8C8D', fontSize: 12 }}>{record.username}</div>
          </div>
        </Space>
      ),
    },
    {
      title: 'Telefon',
      dataIndex: 'phone',
      key: 'phone',
      render: (phone: string | null) => phone || '-',
    },
    {
      title: 'Holat',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (active: boolean) => (
        <Tag color={active ? 'green' : 'default'}>
          {active ? 'Faol' : 'Nofaol'}
        </Tag>
      ),
    },
    {
      title: 'Oxirgi kirish',
      dataIndex: 'lastLoginAt',
      key: 'lastLoginAt',
      render: (date: string | null) =>
        date ? new Date(date).toLocaleString('uz-UZ') : '-',
    },
    {
      title: 'Yaratilgan',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date: string) => new Date(date).toLocaleDateString('uz-UZ'),
    },
    {
      title: 'Amallar',
      key: 'actions',
      render: (_: unknown, record: Staff) => (
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => show('admin/staff', record.id)}
        />
      ),
    },
  ];

  return (
    <List
      title="Xodimlar"
      headerButtons={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => create('admin/staff')}
        >
          Yangi xodim
        </Button>
      }
    >
      <Table {...tableProps} columns={columns} rowKey="id" />
    </List>
  );
};
